module.exports = __webpack_public_path__ + "static/media/5.336fe6ab.png";